module.exports = __webpack_public_path__ + "media/images/warnings/warning_4-32bf2ac66e929183b0df80d8a801bd39.svg";